import React from 'react';
import styles from './DocketAdministration.module.css'
import Construction from "../General/loading/construction";
import AdminChangeRequests from "./ChangeRequests/AdminChangeRequests";

const DocketAdministration = () => {
    return (
        <div className={styles.parent}>

            <div className={styles.pipeline}>
                <p>Pipeline tracking in future update</p>
            </div>

            <div className={styles.buttons}>
                <p>Docket Control Buttons in Future Update</p>
            </div>

            <div className={styles.tables}>
                <div className={styles.temp_construction}>
                    <p>MC/Keyword Table Here in Future Update</p>
                </div>
                <AdminChangeRequests />
            </div>
        </div>
    );
};

export default DocketAdministration;